const DEFAULT_PAGE_SIZE = 100

export default {
  data() {
    return {
      paperListPageIndex: 1,
      paperListPageSize: DEFAULT_PAGE_SIZE,
      paperListTotalCount: 0,
      paperListLastPageSize: 0,
      paperListReachedEnd: false,
      paperListAppendLoading: false
    }
  },
  computed: {
    paperListPageCount() {
      const total = Number(this.paperListTotalCount)
      const pageSize = this.getPaperListPageSize()
      if (!Number.isFinite(total) || total <= 0) {
        return Math.max(1, Number(this.paperListPageIndex) || 1)
      }
      return Math.max(1, Math.ceil(total / pageSize))
    },
    paperListPaginationTotal() {
      const total = Number(this.paperListTotalCount)
      if (Number.isFinite(total) && total > 0) {
        return Math.floor(total)
      }
      const items = Array.isArray(this.paperItems) ? this.paperItems.length : 0
      const pageIndex = Math.max(1, Number(this.paperListPageIndex) || 1)
      const inferredTotal = (pageIndex - 1) * this.getPaperListPageSize() + Math.max(0, Number(this.paperListLastPageSize) || 0)
      return Math.max(items, inferredTotal)
    },
    hasNextPaperListPage() {
      if (this.paperListReachedEnd) {
        return false
      }
      const total = Number(this.paperListTotalCount)
      if (Number.isFinite(total) && total > 0) {
        return (Number(this.paperListPageIndex) || 1) < this.paperListPageCount
      }
      return Math.max(0, Number(this.paperListLastPageSize) || 0) >= this.getPaperListPageSize()
    },
    paperListBottomLoading() {
      return this.paperListAppendLoading
    }
  },
  methods: {
    getPaperListPageSize() {
      const pageSize = Number(this.paperListPageSize)
      return Number.isFinite(pageSize) && pageSize > 0 ? Math.floor(pageSize) : DEFAULT_PAGE_SIZE
    },
    normalizePaperListLoadOptions(options = {}) {
      const source = options && typeof options == 'object' ? options : {}
      const append = source.append === true
      let pageIndex = Number(source.pageIndex)
      if (!Number.isFinite(pageIndex) || pageIndex <= 0) {
        pageIndex = append ? (Number(this.paperListPageIndex) || 1) + 1 : 1
      }
      return {
        append,
        pageIndex: Math.max(1, Math.floor(pageIndex)),
        silent: source.silent === true,
        preserveScroll: source.preserveScroll === true
      }
    },
    applyPaperListPage(payload, nextItems, options = {}) {
      const list = Array.isArray(nextItems) ? nextItems : []
      const total = this.extractPaperListTotalCount(payload)
      const pageIndex = Math.max(1, Number(options.pageIndex) || 1)
      const pageSize = this.getPaperListPageSize()

      this.paperListPageIndex = pageIndex
      this.paperListLastPageSize = list.length
      this.paperListTotalCount = total
      this.paperItems = options.append ? this.mergePaperListItems(this.paperItems, list) : list
      this.paperListReachedEnd = total > 0
        ? pageIndex >= Math.max(1, Math.ceil(total / pageSize)) || list.length < pageSize
        : list.length < pageSize
    },
    resetPaperListPagination() {
      this.paperListPageIndex = 1
      this.paperListTotalCount = 0
      this.paperListLastPageSize = 0
      this.paperListReachedEnd = false
      this.paperListAppendLoading = false
    },
    mergePaperListItems(currentItems, nextItems) {
      const merged = Array.isArray(currentItems) ? currentItems.slice() : []
      const seen = new Set(merged.map(item => item && item.id).filter(Boolean))
      ;(Array.isArray(nextItems) ? nextItems : []).forEach(item => {
        const id = item && item.id
        if (id && seen.has(id)) {
          return
        }
        if (id) {
          seen.add(id)
        }
        merged.push(item)
      })
      return merged
    },
    extractPaperListTotalCount(payload, depth = 0) {
      if (!payload || typeof payload != 'object' || depth > 4) {
        return 0
      }
      const keys = ['total', 'totalCount', 'count', 'totalSize', 'totalElements', 'totalRecords', 'recordCount', 'allCount', 'dataTotal']
      for (let i = 0; i < keys.length; i++) {
        const value = Number(payload[keys[i]])
        if (Number.isFinite(value) && value >= 0) {
          return Math.floor(value)
        }
      }
      const values = Object.keys(payload).map(key => payload[key])
      for (let i = 0; i < values.length; i++) {
        const total = this.extractPaperListTotalCount(values[i], depth + 1)
        if (total > 0) {
          return total
        }
      }
      return 0
    },
    loadNextPaperListPage() {
      if (this.paperListLoading || this.paperListAppendLoading || !this.hasNextPaperListPage) {
        return
      }
      this.loadPaperList({
        pageIndex: (Number(this.paperListPageIndex) || 1) + 1,
        append: true
      })
    },
    handlePaperListScroll(event) {
      const target = event && event.target ? event.target : this.$refs.paperListArea
      if (!target || this.paperListLoading || this.paperListAppendLoading || !this.hasNextPaperListPage) {
        return
      }
      const distance = target.scrollHeight - target.scrollTop - target.clientHeight
      if (distance <= 80) {
        this.loadNextPaperListPage()
      }
    },
    scrollPaperListToTop() {
      this.$nextTick(() => {
        const target = this.$refs.paperListArea
        if (target) {
          target.scrollTop = 0
        }
      })
    }
  }
}
